export default "__VITE_ASSET__BjnCf6FM__"